module.exports = __webpack_public_path__ + "img/wave-1-gray-200_3.380d103.png";